// Людська назва джерела кандидата. Application.source — це канал доставки
// (майже завжди "peopleforce", бо відгуки з джобсайтів їдуть через
// PeopleForce, ADR-005); справжнє походження лежить у peopleforce_source
// (PF «Ресурс»: work.ua / robota.ua / «Додано вручну» / «ІІ»), яке
// проставляє fetch_cv-воркер. Невідомі значення показуємо як є.
const JOB_SITE_LABELS: Record<string, string> = {
  'work.ua': 'Work.ua',
  work_ua: 'Work.ua',
  workua: 'Work.ua',
  'robota.ua': 'Robota.ua',
  'rabota.ua': 'Robota.ua',
  robota_ua: 'Robota.ua',
  rabota_ua: 'Robota.ua',
};

const CHANNEL_LABELS: Record<string, string> = {
  peopleforce: 'PeopleForce',
  work_ua: 'Work.ua',
  robota_ua: 'Robota.ua',
  manual: 'Вручну',
};

export function candidateSourceLabel(
  source: string,
  peopleforceSource?: string | null,
): string {
  if (peopleforceSource) {
    const key = peopleforceSource.trim().toLowerCase();
    return JOB_SITE_LABELS[key] ?? peopleforceSource;
  }
  return CHANNEL_LABELS[source] ?? source;
}
